const initialState = {
    isFetchingGetJudgementData: false,
    isFetchingPostJudgementData: false,
    array: [],
};

const EntryofJudgementNoticeReducer = (state = initialState, action) => {
    switch(action.type){
        case "REQUEST_GET_JUDGEMENT_DATA":
            return{...state, isFetchingGetJudgementData: true,
                isFetchingPostJudgementData: false,
                array: []};
        case "SUCCESS_GET_JUDGEMENT_DATA":
            return{
                ...state, 
                array: action.payload.data,
                isFetchingGetJudgementData: false};
        case "ERROR_GET_JUDGEMENT_DATA":
            return{...state, isFetchingGetJudgementData: false};


        case "REQUEST_POST_JUDGEMENT_DATA":
            return{...state, isFetchingPostJudgementData: true};
        case "SUCCESS_POST_JUDGEMENT_DATA":
            return{...state, isFetchingPostJudgementData: false };
        case "ERROR_POST_JUDGEMENT_DATA":
            return{...state, isFetchingPostJudgementData: false};


        default:
            return state;
    }
}

export default EntryofJudgementNoticeReducer
